module.exports = __webpack_public_path__ + "img/06.251be636.jpg";